import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API } from '../../../constants/app-service-constants';
import { ModalDeliveryShareModel } from '../../../../core/models';

@Injectable()
export class ModalDeliveryShareService {
  constructor(private http: HttpClient) {}

  getSharedReasons(): Observable<any> {
    return this.http.get(API.GET_SHARE_DELIVERY_REASONS);
  }

  sendDelivery(body: ModalDeliveryShareModel): Observable<any> {
    return this.http.post(API.SHARE_DELIVERY, body);
  }
}
